import React from "react";
import moment from "moment";

const FormatDateTime = ({ date }) => {
  return <span>{moment(date).format("MMMM Do YYYY, h:mm:ss a")}</span>;
};

export default FormatDateTime;
